import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppState, AuthActionTypes } from '@app/core/ngrx';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

@Component({
    selector: 'ecp-sso-callback',
    template: `
    <div class="loader">
      <div class="loader-icon">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  `,
    standalone: false
})
export class AuthSSOCallbackComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private store: Store<AppState>,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // this.authService
    //   .parseTokensFromURL()
    //   .then(tokens => {
    //     if (!tokens) throw new Error('SSO Callback: No Tokens parsed');

    //     this.authService.setTokens(tokens);
    //     this.router.navigateByUrl(
    //       window.localStorage.getItem('returnUrl') || 'dashboard',
    //       { replaceUrl: true },
    //     );

    //     this.store.dispatch({ type: AuthActionTypes.LOGIN_SUCCESS });
    //     window.localStorage.removeItem('returnUrl');
    //   })
    //   .catch(err => {
    //     this.store.dispatch({
    //       type: AuthActionTypes.LOGIN_ERROR,
    //       payload: err,
    //     });
    //     console.error(
    //       '> AuthSSOCallbackComponent - ngOnInit() - error => ',
    //       err,
    //     );
    //     this.router.navigateByUrl('', { replaceUrl: true });
    //   });
  }
}
